import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { IPdfStrings } from "@services/pdf/generator"

/** PDF-drawn strings resolved through i18n at generation time (iOS parity). */
export function usePdfStrings(): IPdfStrings {
	const { t } = useTranslation()
	return useMemo(
		() => ({
			confidentialTop: t("pdfBuilder.confidentialTop"),
			confidentialBottom: t("pdfBuilder.confidentialBottom"),
			poweredBy: t("pdfBuilder.poweredBy", { creator: "{{creator}}", interpolation: { escapeValue: false } }),
			taxMessage: t("pdfBuilder.taxMsg"),
		}),
		[t]
	)
}
